import PRICING from "@/shared/pricing.json";

// Darija (Moroccan Arabic) copy. French is kept only where it is printed on the product.
// The price comes from src/shared/pricing.json, which backend/server.py reads too.
export const da = {
  dir: "rtl",
  lang: "ar-MA",
  brand: "Lurio",
  bookTitle: "Ma Grande Aventure Scolaire",
  price: `${PRICING.unit_price} درهم`,
  priceValue: PRICING.unit_price,
  currency: "درهم",
  cta: "كوماندي دابا",
  ctaSub: "الخلاص عند التوصيل",
  nav: { order: "كوماندي", inside: "الكتاب", nori: "Nori", faq: "أسئلة" },

  // label/placeholder/honest were the Hero name-input's copy (removed); fallback is still used
  // by the InsideBook ownership-page preview and DiplomaCard, which keep their own name preview.
  namePrompt: {
    fallback: "المستكشف الصغير",
  },

  hero: {
    eyebrow: "كتاب أنشطة عبارة عن 60 مهمة موجه للأطفال في سن 5 - 6 سنوات",
    lines: ["أساسيات الفرنسية للطفل", "إستعدادا للمستوى", "الدراسي الأول"],
    support: "الكتاب مبني على طريقة تعليم تدريجية للغة الفرنسية، 60 مهمة قصيرة، فيها ولدك كيتعلم يلاحظ، يفكر و يركّز — و معاه Nori، المساعد المستكشف ديالو اللي كيرافقو مهمة بمهمة.",
    chips: ["60 مهمة", "5 عوالم", "أطفال 5-6 سنوات"],
    coverAlt: "الغلاف ديال كتاب Lurio – Ma Grande Aventure Scolaire، Nori الفنك المستكشف",
  },

  trust: ["الخلاص عند التوصيل", "التوصيل مجانا لجميع مدن المغرب", "تصميم بمنهج علمي", "صور ملونة توضيحية", "60 مهمة · 5 عوالم"],

  promise: {
    eyebrow: "قاعدة علمية",
    statement: ["الطفل كيتعلم مزيان", "ملي كيلعب.", "ماشي ملي كيتضغط عليه."],
    body: "Ma Grande Aventure Scolaire ماشي دفتر ديال الواجبات. هو كتاب ديال المغامرات: كل صفحة عبارة عن مهمة، و نجاح كل مهمة صغيرة تعني نجاح للطفل كيشوفو بعينيه و كيفرح بيه.",
    benefits: [
      { n: "01", title: "الثقة فالنفس", text: "كل مهمة كتسالي بنجاح واضح. الطفل كيفهم بلي هو قادر." },
      { n: "02", title: "الاستعداد للفرنسية", text: "تعليمات قصيرة، أول الحروف، الأصوات و كلمات القسم — بلا درس و بلا حفظ." },
      { n: "03", title: "التركيز", text: "10 دقايق في اليوم، قلم و صفحة. الطفل كايركز مزيان باش يكمل المهمة." },
    ],
    margin: "تقراوها بجوج، على طابلة الكوزينة",
  },

  nori: {
    eyebrow: "تعرف على Nori",
    title: "هاد الثعلب الصغير هو المرافق د ولدك طيلة رحلة الكتاب",
    body: "Nori بالشكل الظريف ديالو وشخصيته المرحة كيخلي ولدك يكمل مهمات الكتاب دون الشعور بالملل",
    poses: [
      { id: "regarde", printed: "REGARDE", da: "شوف" },
      { id: "reflechis", printed: "RÉFLÉCHIS", da: "فكّر" },
      { id: "fais", printed: "FAIS", da: "جاوب" },
    ],
    posesNote: "الطريقة ديال Nori، كيف مطبوعة فالكتاب: شوف، فكّر، جاوب.",
    promiseTitle: "الوعد ديال Nori لولدك",
    promise: "«عمري ما غادي نطلب منك تزرب. غادي نطلب منك تلاحظ مزيان، تجرّب، و تعاود شحال ما بغيتي. فكل مهمة، كنمشيو بجوج.»",
    signature: "— Nori",
  },

  inside: {
    eyebrow: "من داخل الكتاب",
    title: "كتاب كيتحل بحال مغامرة.",
    hint: "سكرولي باش تقلب الصفحات",
    ownershipPrinted: "Ce livre appartient à…",
    spreads: [
      { id: "ownership", slot: "page_ownership", label: "الصفحة 1", printed: "Ce livre appartient à…", note: "أول مهمة: يكتب سميتو بيدو" },
      { id: "maze", slot: "page_maze", label: "Mission 18", printed: "Choisis le chemin le plus court !", note: "قلم، طريق، و مخرج" },
      { id: "differences", slot: "page_differences", label: "Mission 19", printed: "Trouve les 4 choses qui ont changé !", note: "اللي كيلاحظ، راه بدا كيفكر" },
      { id: "pattern", slot: "page_pattern", label: "Mission 10", printed: "Que vient-il après ?", note: "شنو اللي جاي من بعد؟" },
      { id: "code", slot: "page_code", label: "Mission 57", printed: "Le code secret de Nori !", note: "كل رمز مخبي حرف" },
    ],
  },

  badges: {
    eyebrow: "5 عوالم · 5 بادجات",
    title: "طريق واحد، خمس محطات، و ديبلوم.",
    body: "كل عالم فيه 12 مهمة. ملي كيكمل العالم، الطفل كيلصق البادج ديالو. من بعد خمسة ديال البادجات، كيتسناه Diplôme d'Explorateur.",
    items: [
      { id: "depart", name: "Badge Départ", world: "Prêt pour l'aventure", n: 1, missions: 12, skill: "يشد القلم و يبدا" },
      { id: "observation", name: "Badge Observation", world: "Quartier des Explorateurs", n: 2, missions: 12, skill: "يشوف بعينين مفتوحين" },
      { id: "ecole", name: "Badge École", world: "École de l'Aventure", n: 3, missions: 12, skill: "قوانين القسم" },
      { id: "reflexion", name: "Badge Réflexion", world: "Quête des Grandes Idées", n: 4, missions: 12, skill: "المنطق و السلاسل" },
      { id: "super", name: "Badge Super Explorateur", world: "Jour de l'Explorateur", n: 5, missions: 12, skill: "كلشي مجموع" },
    ],
    worldLabel: "العالم",
    missionsLabel: "مهمة",
  },

  credibility: {
    eyebrow: "البيداغوجيا",
    title: "مهارات محددة، كيتعلمها بلا ما يحس.",
    skills: [
      { name: "الملاحظة", text: "يلقى، يقارن، يعرف الغريب." },
      { name: "المنطق", text: "سلاسل، ترتيب، و أول الاستنتاجات." },
      { name: "الحركات الدقيقة", text: "يخطط، يوصل، يلوّن داخل الإطار." },
      { name: "أول الحروف", text: "يعرف حروف و أصوات سميتو." },
      { name: "الذاكرة", text: "يحفظ تعليمة، صورة، أو ترتيب." },
      { name: "تطبيق التعليمة", text: "يقرا قاعدة بسيطة و يطبقها بوحدو." },
    ],
    whyTitle: "علاش كيخدم",
    why: [
      { title: "مهام قصيرة", text: "صفحة، تعليمة، نجاح. تركيز الطفل ديال 5 سنين كيدوم مدة مهمة واحدة." },
      { title: "صعوبة تدريجية", text: "العالم 1 كيعطي الثقة. العالم 5 كيخلي يفكر. بيناتهم، الطفل ما كيحس بوالو." },
      { title: "تشجيع فكل صفحة", text: "Nori كيهنّي، عمرو ما كيصحح بالأحمر. الغلطة طريق، ماشي عيب." },
    ],
    parentsTitle: "للوالدين: حصة ديال 10 دقايق",
    parents: [
      { time: "1 دقيقة", text: "الطفل كيختار المهمة ديالو فالعالم اللي واصل فيه." },
      { time: "7 دقايق", text: "كيخدم بوحدو. نتا حداه، بلا ما تدخل." },
      { time: "2 دقايق", text: "تشوفو بجوج، تعلّمو، تهنّيه. سالات الحصة." },
    ],
  },

  quality: {
    eyebrow: "جودة كتحسها فيديك",
    title: "ورق كيعطيك النفس تمسّو.",
    stamp: "تصميم مغربي أصلي",
    stampSub: "متصور و مرسوم لولاد المغرب",
    spiralTitle: "علاش سبيرال؟",
    spiral: "الكتاب كيبقى محلول مسطح، بلا ما يد تشد الصفحة. اليدين الصغار كيخدمو مرتاحين، و القلم كيوصل حتى للحاشية. اختيار مفكر فيه للورق و القلم، ماشي للرفّ.",
    specs: [
      { k: "الحجم", v: "A4 · 21 × 29,7 cm" },
      { k: "الصفحات", v: "بالألوان، ورق غليظ" },
      { k: "التجليد", v: "سبيرال، كيتحل مسطح" },
      { k: "المهام", v: "60 · 5 عوالم · 5 بادجات" },
    ],
  },

  diploma: {
    eyebrow: "آخر نهار",
    title: "اللحظة اللي كيكمل فيها الكتاب.",
    body: "من بعد المهمة 60، كتسنى الطفل آخر صفحة: Diplôme d'Explorateur. بلا نقطة. غير دليل بلي وصل حتى للآخر.",
    previewNote: "معاينة — فالكتاب، الطفل كيكتب سميتو بيدو على هاد الخط.",
    hand: "تعلّقوه فالحيط، ولا تخليوه فالكتاب",
    alt: "الصفحة ديال Diplôme d'Explorateur فالكتاب، مع الخمسة ديال البادجات و Nori",
  },

  order: {
    eyebrow: "كوماندي",
    title: "الكتاب كيجيك حتى للدار، و تخلص عند الباب.",
    body: "عمّر هاد الفورم، و كنأكدو كل كوموند على واتساب قبل الإرسال. كتخلص الليفرور ملي يوصلك الكتاب.",
    priceNote: "التوصيل + الخلاص عند الاستلام",
    reassurance: "كنأكدو كل كوموند على واتساب.",
    fields: { full_name: "الاسم الكامل", phone: "التيليفون (واتساب)", city: "المدينة", quantity: "العدد" },
    placeholders: { full_name: "مثلا: سلمى بناني", phone: "06 12 34 56 78", city: "كازا" },
    submit: "كوماندي دابا",
    submitting: "كنصيفطو…",
    whatsapp: "كوماندي على واتساب",
    or: "ولا",
    total: "المجموع عند التوصيل",
    error: "وقع مشكل. عاود جرّب ولا كتب لينا على واتساب.",
    waMessage: `السلام، بغيت نكوماندي Lurio – Ma Grande Aventure Scolaire (${PRICING.unit_price} درهم).`,
    success: {
      title: "شكراً بزاف. الكوموند ديالك وصلات.",
      body: "غادي نكتبو ليك على واتساب باش نأكدو العنوان و التوصيل. ما كتخلص والو قبل ما يكون الكتاب فيدك.",
      ref: "الرقم",
      again: "كوموند أخرى",
    },
  },

  faq: {
    eyebrow: "أسئلة",
    title: "اللي كيسولو عليه الوالدين بزاف.",
    items: [
      { q: "لشمن عمر مناسب هاد الكتاب؟", a: "من 5 حتى 6 سنين، يعني العام اللي قبل المدرسة الكبيرة و بداية CP. شي ولاد ديال 4 سنين و نص كيبداو العالم 1 مع الوالد، و ولاد 7 سنين كيكملوه دغيا و لكن بفرحة." },
      { q: "خاص شي مستوى فالفرنسية؟", a: "لا، ما خاص حتى شي حاجة. التعليمات قصيرة، مرسومة، و مفكر فيها باش تتقرا بجوج فالأول. الكتاب كيدخل بشوية الحروف، الأصوات و كلمات القسم." },
      { q: "شحال كيدوز التوصيل؟", a: "كنأكدو كل كوموند على واتساب، و من بعد الكتاب كيتوصل لجميع مدن المغرب، عادةً ما بين 24 و 72 ساعة على حساب المدينة. كتخلص الليفرور ملي يوصلك." },
      { q: "و إلا ما عجبنيش الكتاب؟", a: "كتشوف الكتاب عند الباب قبل ما تخلص. إلا وصل شي نسخة مخسرة، كنبدلوها ليك. غير كتب لينا على واتساب." },
      { q: "كيفاش كتدوز الحصة؟", a: "10 دقايق كافيين. الطفل كيختار مهمة، كيديرها بوحدو، و من بعد كتشوفو بجوج و تعلّمو عليها. مهمة ولا جوج كل نهار، و العالم كيكمل فجوج سيمانات." },
    ],
  },

  final: {
    line: ["فكل طفل", "كاين مستكشف."],
    sub: "الكتاب كيوصل حتى للدار. كتخلص ملي يكون بين يديه.",
  },

  footer: {
    tagline: "كتاب أنشطة باش ولدك يدخل للمدرسة الكبيرة و قلبو مطمن.",
    whatsappLabel: "كتب لينا على واتساب",
    legal: "© Lurio · متصور و مرسوم فالمغرب",
    made: "تصميم مغربي أصلي",
  },

  sticky: { price: `${PRICING.unit_price} درهم · الخلاص عند التوصيل` },
  floatingWhatsapp: "واتساب",
  progressLabel: "التقدم فالصفحة",
  photoSlot: "بلاصة الصورة",
};

export default da;
